import { cn } from '~/lib/utils'
import Icon, { IconProps } from '~/components/Helpers/Icon'

type LargeStatisticProps = {
  content: {
    heading: string
    icon?: IconProps['icon']
    character?: string
    type: 'icon' | 'alphanumeric'
    decorative: boolean
    alignment: 'left' | 'centred'
  }
  layoutColour?: AllBackgroundColours
  className?: string
}

const LargeStatistic = ({
  content,
  layoutColour,
  className
}: LargeStatisticProps) => {
  const { heading, type, decorative, alignment } = content

  const icon = Array.isArray(content.icon) ? content.icon[0] : content.icon
  const character = content.character || '1'

  return (
    <div
      className={cn(
        className,
        'sm:gap-s lg:gap-m gap-xs-plus flex w-fit flex-col',
        `${alignment === 'centred' ? 'items-center' : ''}`
      )}
    >
      <div className='flex'>
        {icon && type === 'icon' && (
          <Icon
            className={cn(
              'object-cover [&>img]:w-2xl sm:[&>img]:w-[96px] lg:[&>img]:w-3xl'
            )}
            icon={icon}
            backgroundColour={layoutColour}
          />
        )}
        {(type === 'alphanumeric' || !icon) && (
          <span className='text-h1-lg font-serif sm:text-[80px] lg:text-[96px]'>
            {character.toUpperCase()}
          </span>
        )}
      </div>

      <h2
        className={cn(
          decorative ? 'font-serif font-normal' : '',
          `${alignment === 'centred' ? 'text-center' : ''}`
        )}
      >
        {heading}
      </h2>
    </div>
  )
}

export default LargeStatistic
